import './index.css';
import * as React from 'react';
import { ScenceTabItemData } from '../component';

interface State {}

interface Props {
  scenceTabData: ScenceTabItemData;
  isSelected: boolean;
}

/**
 * 文本选择组件
 * @param apiData
 */
export default class ScenceTabTextItem extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  componentDidMount(): void {

  }

  componentWillUnmount(): void {

  }

  render() {
    const { text, textPic } = this.props.scenceTabData || {};
    return (
      <view className="container">

        {/* 图片内容 */}
        {textPic && <image className="option-image" src={textPic} resizeMode="heightFix" />}

        {/* 文字内容 */}
        {!textPic && <text className={this.props.isSelected ? 'text-selected' : 'text-normal'} content={text} />}

        {/* 选中状态 */}
        {this.props.isSelected && <view className="text-baseline" />}
      </view>
    );
  }
}
